import { logDOM } from "@testing-library/react";
import { useEffect, useState } from "react";
import Country from "./Country/Country";
import './Countriesapi.css'

const Countriesapi = () => {

 const [countries,setCountries] = useState([])

 useEffect(()=>{
  fetch('https://restcountries.com/v3.1/all')
  .then(res => res.json())
  .then(data => setCountries(data))
 },[])
 return (
  <div>
   <h1>Hello REact Js : {countries.length}</h1>
  <div className="countries-container">
  

{/* THIS ONE METHOD HOW DISPLLAY DATA ESALY 
BUT YOU HAVE TO SENT DATA IN DETAILS */}
   {/* {
    countries.map(country => 
    <Country name ={country.name.common} 
    population = {country.population}
    area = {country.area}
    ></Country>
    )
   } */}

{/* HERE YOU ARE SENDING A SING DATA BUT WILL GET ALL 
DATA WHEN YOU CALL TO DISPLAY DATA  */}
   
    {
    countries.map(country => 
    <Country country ={country} 
    key = {country.cca3}
    // population = {country.population}
    // area = {country.area}
    ></Country>
    )
   } 

  </div>
  </div>
 );

};

export default Countriesapi;